import React from 'react';
import Terminal from "./Terminal";
import {Box} from "@mui/material";
import {info} from "../../info/Info";


export default function About({innerRef}) {
    const firstName = info.firstName.toLowerCase()

    function aboutMeText() {
        return (
            <>
                <p style={{color: "#1f1f1f", fontFamily: "RobotoRegular, sans-serif", fontSize: "17px"}}>
                    🌟 Hello! I’m a Ph.D. student in Artificial Intelligence at the
                    <a href="https://www.unicampus.it/en/" target="_blank" rel="noopener noreferrer"
                       style={{color: "#000000", textDecoration: "none"}}> University Campus Bio-Medico of Rome </a>
                    (UCBM), where I conduct my research within the
                    <a href="http://www.cosbi-lab.it" target="_blank" rel="noopener noreferrer"
                       style={{color: "#000000", textDecoration: "none"}}> Computer Systems and Bioinformatics (CoSBi) </a>
                    Lab. My work focuses on advancing innovation in the Health and Life Science domain.
                </p>
                <p style={{color: "#1f1f1f", fontFamily: "RobotoRegular, sans-serif", fontSize: "17px"}}>
                    ⏰ I hold a Master of Science in Biomedical Engineering, which I completed with distinction, with a
                    thesis developed in collaboration with Bracco Imaging S.p.A. and the Breast Unit at the UCBM
                    Polyclinic, centered on virtual contrast enhancement in Contrast Enhanced Spectral Mammography
                    (CESM). Additionally, I earned my Bachelor of Science in Medical Engineering from the
                    <a href="https://web.uniroma2.it/en" target="_blank" rel="noopener noreferrer"
                       style={{color: "#000000", textDecoration: "none"}}> University of Rome Tor Vergata</a>,
                    graduating with top honors.
                </p>
                <p style={{color: "#1f1f1f", fontFamily: "RobotoRegular, sans-serif", fontSize: "17px"}}>
                    💡My recent projects involve using GANs and Diffusion Models to
                    advance biomedical imaging, and multimodal learning to improve breast cancer diagnostics.
                </p>
                <p style={{color: "#1f1f1f", fontFamily: "RobotoRegular, sans-serif", fontSize: "17px"}}>
                    👩‍🎓 <strong>Supervising Students</strong> As a mentor, I’ve had the honor of guiding brilliant
                    students:
                </p>

                <ul style={{
                    fontFamily: "RobotoRegular, sans-serif",
                    fontSize: "17px",
                    listStyleType: "disc",
                    paddingLeft: "20px"
                }}>

                    <li style={{color: "#000000", fontFamily: "RobotoRegular, sans-serif", fontSize: "17px"}}>
                        <a href="https://www.linkedin.com/in/arianna-manchia-920a73190/" target="_blank"
                           rel="noopener noreferrer"
                           style={{color: "#000000", textDecoration: "none"}}>
                            Arianna Manchia
                        </a>: M.Sc. in Biomedical Engineering at UCBM
                    </li>
                    <li style={{
                        color: "#000000",
                        fontFamily: "RobotoRegular, sans-serif",
                        fontSize: "17px"
                    }}>
                        <a href="https://www.linkedin.com/in/carlo-di-cicco-187053301/" target="_blank"
                           rel="noopener noreferrer"
                           style={{color: "#000000", textDecoration: "none"}}>
                            Carlo Di Cicco
                        </a>: B.Sc. in Industrial Engineering at UCBM
                    </li>
                </ul>

                <p style={{color: "#1f1f1f", fontFamily: "RobotoRegular, sans-serif", fontSize: "17px"}}>
                    👩🏻‍🏫 <strong>Teaching</strong> I have taught the following courses:
                    <ul style={{
                        fontFamily: "RobotoRegular, sans-serif",
                        fontSize: "17px",
                        listStyleType: "disc",
                        paddingLeft: "20px"
                    }}>
                        <li style={{color: "#000000", fontFamily: "RobotoRegular, sans-serif", fontSize: "17px"}}>
                            Spring 2024: Teaching Assistant for Machine Learning & Big Data Analytics at University
                            Campus Bio-Medico of Rome
                        </li>
                    </ul>
                </p>
                <p style={{color: "#1f1f1f", fontFamily: "RobotoRegular, sans-serif", fontSize: "17px"}}>
                    🎙️ <strong>Invited Talks</strong> I have given:
                    <ul style={{
                        fontFamily: "RobotoRegular, sans-serif",
                        fontSize: "17px",
                        listStyleType: "disc",
                        paddingLeft: "20px"
                    }}>
                        <li style={{color: "#000000", fontFamily: "RobotoRegular, sans-serif", fontSize: "17px"}}>
                            September 2023: Exploring Artificial Intelligence at the Medicine & Surgery and MedTech
                            Summer School, University Campus Bio-Medico of Rome.
                        </li>
                    </ul>
                </p>
            </>
        );
    }


    return (
        <Box ref={innerRef} display={'flex'} flexDirection={'column'} alignItems={'center'} mt={'3rem'} id={'about'}>
            <Terminal text={aboutMeText()}/>
        </Box>
    )

}